export const SENTRY_SIGN_UP_LOGGER = 'SENTRY_SIGN_UP_LOGGER';
